import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.Import employees' | translate }}</h1>
        </div>
        <div class="alert alert-plain">
            <p>{{ 'user.Helpful tips for a successful import' | translate }}:</p>
            <ol>
                <li>
                    <p>
                        <strong>{{ 'user.From this view You can import new employees and renew existing employees.' | translate }}</strong>
                        {{ 'user.This view can not be used for updating/deleting already existing employees' | translate }}
                    </p>
                </li>
                <li><p>{{ 'user.Employees sites must be created separately before the import' | translate }}</p></li>
                <li><p>{{ 'user.Employees Departments, Roles and Levels will be automatically created by the system upon import. Please mind the spelling' | translate }}</p></li>
                <li><p>{{ 'user.If you wish to assign direct managers, import them separately and before their employees' | translate }}</p></li>
                <li><p>{{ 'user.To define multiple positions for the employee, every Department, Role, Level combination must be entered on a separate row' | translate }}</p></li>
                <li><p>{{ vm.translationText6 | translate }}</p></li>
                <li>
                    <p>
                        <strong>{{ 'user.The changes may mix up employees data!' | translate }}</strong>
                        {{ 'user.If you are not sure that the template is correct, then before updating, contact our customer support on support@coursy.io' | translate }}
                    </p>
                </li>
            </ol>
        </div>
        <h2 class="hasno">
            <span class="no">1</span> {{ 'user.Download the template below (optional)' | translate }}
        </h2>
        <div class="well type03">
            <p>
                <a ng-click="vm.downloadTemplate()" class="btn mt10 bordered02 small">
                    {{ 'user.Download template' | translate }}
                </a>
            </p>
            <p class="desc muted">({{ 'general.updated' | translate }}: 25.04.2023)</p>
        </div>
        <h2 class="hasno">
            <span class="no">2</span> {{ 'user.Upload completed template' | translate }}
        </h2>
        <div class="alert alert-success " ng-if="vm.success" ng-bind-html="vm.success"></div>
        <div class="alert alert-danger" ng-if="vm.generalErrorHtml" ng-bind-html="vm.generalErrorHtml"></div>
        <form ng-submit="vm.importUsers()" enctype="multipart/form-data">
            <div class="well type03">
                <div class="form">
                    <form-row error="vm.form.errors.file">
                        <ul class="actions01">
                            <li class="fileupload">
                                <input ngf-select="vm.setFile($file)" ng-model="vm.form.file" type="file">
                                <a class="btn small main">{{ 'user.Upload template' | translate }}</a>
                            </li>
                        </ul>
                        <form-row-error></form-row-error>
                    </form-row>
                    <p class="note" ng-if="vm.form.file">{{ 'general.Selected file' | translate }}: {{vm.form.file.name}}</p>
                    <div class="row has-error" ng-if="vm.form.errors.excel">
                        <label class="label">{{ 'import.Excel errors' | translate }} *</label>
                        <div class="items">
                            <p ng-repeat="(row, errors) in vm.form.errors.excel" ng-bind-html="vm.getExcelRowErrors(row, errors)"></p>
                        </div>
                    </div>
                </div>
            </div>
            <ul class="actions01">
                <li class="primary"><button ng-if="vm.importInProgress === false" type="submit" class="btn main">{{ 'user.Import' | translate }}</button></li>
            </ul>
        </form>
        <div ng-if="vm.importInProgress">
            <h2>
                {{ 'user.Import progress' | translate }} <small ng-if="vm.totalCount"
                >{{ vm.progressPc | number:2 }}% ({{ vm.importedCount }}/{{ vm.totalCount }})</small>
            </h2>
            <div class="progress01 margt">
                <span style="width: {{ vm.progressPc }}%">{{ vm.progressPc }}%</span>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $sce, $interval, $window, lodash, toastr, Upload,
                 fileMd5Service, SiteService, ModalService, UserResource, AuthResource,
                 USER_CUSTOM_ERROR_ENUM) {
        this.$translate = $translate;
        this.$sce = $sce;
        this.$interval = $interval;
        this.$window = $window;
        this.lodash = lodash;
        this.toastr = toastr;
        this.Upload = Upload;
        this.fileMd5Service = fileMd5Service;
        this.SiteService = SiteService;
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.AuthResource = AuthResource;
        this.USER_CUSTOM_ERROR_ENUM = USER_CUSTOM_ERROR_ENUM;

        this.initTranslationText();
    }

    initTranslationText () {
        this.translationText6 = 'user.To renew employee data only fields that need updating need to be filled. IN addition, ' +
        'for every employee the necessary data to identify the employee, must be filled (personal code + country or e-mail)';
    }

    $onInit () {
        this.form = {};
        this.importInProgress = false;
        this.generalErrorHtml = null;

        this.sites = this.lodash.map(this.SiteService.sites, (value) => {
            return { id: parseInt(value.id, 10), name: value.name };
        });
    }

    setFile (file) {
        this.form.file = file;
        this.success = false;
        this.generalErrorHtml = null;
        this.form.errors = {};
        this.form.notifications = {};
    }

    importUsers (validateNotifications = true) {
        this.importInProgress = true;
        this.progressPc = 0;
        this.importedCount = 0;
        this.totalCount = 0;
        this.success = false;
        this.generalErrorHtml = null;
        this.form.errors = {};
        this.form.notifications = {};

        this.fileMd5Service.md5(this.form.file)
            .success(importId => {
                const importResultsLogInterval = this.$interval(() => {
                    this.UserResource.importLog({ importId }).$promise
                        .then((result) => {
                            this.importedCount = result.importedCount;
                            this.totalCount = result.totalCount;
                            this.progressPc = result.importedCount * 100 / result.totalCount;
                            if (!this.importInProgress) {
                                this.$interval.cancel(importResultsLogInterval);
                            }
                        })
                        .catch(() => {
                            this.$interval.cancel(importResultsLogInterval);
                        });
                }, 1000);
            });

        this.doUpload(validateNotifications);
    }

    doUpload (validateNotifications) {
        const url = `${SEED_CORE.ENV.API_URL}user/user/import${validateNotifications ? '?validateNotifications=true' : ''}`;

        this.Upload.upload({ url, data: { file: this.form.file, siteId: this.form.siteId } })
            .then((response) => {
                this.importInProgress = false;
                this.success = this.getSuccessMessage(response.data);
                this.form.errors = {};
                this.form.notifications = {};
                this.generalErrorHtml = null;
            }).catch((response) => {
                this.success = false;
                this.importInProgress = false;
                this.form.errors = {};
                this.form.notifications = {};
                this.generalErrorHtml = null;

                const handled = this.formatResponseErrors(response);

                if (!handled) {
                    this.generalErrorHtml = this.$sce.trustAsHtml(
                        this.$translate.instant('general.Something went wrong')
                    );
                }

                if (!this.form.errors.excel && this.form.notifications.excel) {
                    this.doConfirmNotifications();
                }
            });
    }

    doConfirmNotifications () {
        const messages = [];

        this.lodash.forOwn(this.form.notifications.excel, (rowsArray, constant) => {
            messages.push(this.getExcelRowNotifications(constant, rowsArray));
        });

        const message = messages.join('<br>');
        this.ModalService.confirm(message, 'large').then(() => {
            this.importUsers(false);
        });
    }

    /**
     * this function is responsible for sorting api returned errors to notifications and errors
     */
    formatResponseErrors (response) {
        let handled = false;

        if (response && Array.isArray(response.data)) {
            response.data.forEach((err) => {
                if (!err) {
                    return;
                }

                const field = err.field;
                const msg = err.message;

                if (msg && typeof msg === 'object' && !Array.isArray(msg)) {
                    this.lodash.forOwn(msg, (messages, row) => {
                        const list = Array.isArray(messages) ? messages : [messages];
                        list.forEach((m) => {
                            if (this.USER_CUSTOM_ERROR_ENUM.KEYS[m]) {
                                if (!this.form.notifications[field]) {
                                    this.form.notifications[field] = {};
                                }
                                if (!this.form.notifications[field][m]) {
                                    this.form.notifications[field][m] = [];
                                }
                                this.form.notifications[field][m].push(row);
                                handled = true;
                            }
                            else {
                                if (!this.form.errors[field]) {
                                    this.form.errors[field] = {};
                                }
                                if (!this.form.errors[field][row]) {
                                    this.form.errors[field][row] = [];
                                }
                                this.form.errors[field][row].push(m);
                                handled = true;
                            }
                        });
                    });
                    return;
                }

                if (field && (typeof msg === 'string' || Array.isArray(msg))) {
                    const list = Array.isArray(msg) ? msg : [msg];
                    const messages = list.filter(Boolean).map(String);

                    if (field === 'file' || field === 'excel') {
                        if (!this.form.errors.excel) {
                            this.form.errors.excel = {};
                        }
                        if (!this.form.errors.excel[0]) {
                            this.form.errors.excel[0] = [];
                        }
                        Array.prototype.push.apply(this.form.errors.excel[0], messages);
                        handled = true;
                        return;
                    }

                    // otherwise use the standard form-row way (expects a string)
                    this.form.errors[field] = messages.join('\n');
                    handled = true;
                }
            });
        }

        return handled;
    }


    getSuccessMessage (data) {
        const created = Number(data && data.created) || 0;
        const updated = Number(data && data.exists) || 0;

        if (!created && !updated) {
            return this.$sce.trustAsHtml(
                this.$translate.instant('user.import.Import completed. No changes were applied')
            );
        }

        const messages = [];
        if (data.created) {
            messages.push(this.$translate.instant('user.import.Created {userCount} new employees', { userCount: created }));
        }
        if (data.exists) {
            messages.push(this.$translate.instant('user.import.Updated {userCount} employees', { userCount: updated }));
        }
        return this.$sce.trustAsHtml(messages.join('<br>'));
    }

    getExcelRowErrors (row, errors) {
        const rowErrors = [];
        this.lodash.forEach(errors, (message) => {
            if (row === '0') {
                rowErrors.push(this.$translate.instant('user.import.Error: {message}',
                    { row, message }
                ));
            }
            else {
                rowErrors.push(this.$translate.instant('user.import.Row {row} error: {message}',
                    { row, message }
                ));
            }
        });
        return this.$sce.trustAsHtml(rowErrors.join('<br>'));
    }

    getExcelRowNotifications (notificationConstant, rowsArray) {
        let message = '';
        if (notificationConstant === this.USER_CUSTOM_ERROR_ENUM.KEYS.USER_NOT_UNIQUE_NAME) {
            message = this.$translate.instant('user.import.user_duplicate_name_notification');
        }
        const rows = rowsArray.join(', ');
        return this.$sce.trustAsHtml(this.$translate.instant('user.import.Affected rows {rows} "{message}"',
            { rows, message }
        ));
    }

    downloadTemplate () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}user/user/export-template?lang=${this.$translate.use()}&tacToken=${token}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/import/index.js